var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Induction = function Induction(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M8 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM13 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2ZM8 16a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM13 15a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.17 4A3.001 3.001 0 0 1 11 2h2c1.306 0 2.418.835 2.83 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17ZM10 5a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm5.83 1H17a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1.17A3.001 3.001 0 0 0 11 8h2a3.001 3.001 0 0 0 2.83-2Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Induction;